import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import CssBaseline from '@material-ui/core/CssBaseline';
import {makeStyles} from '@material-ui/core/styles';
import routes from '../../routes/pages/cadastro'
import Header from '../../components/shared/layout/header';
import Footer from '../../components/shared/layout/footer';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    position: 'relative',
  },
  content: {
    width: '100%',
  },
  mainContent: {
    minHeight: 'calc(100vh - 136px)',
    position: 'relative',
  },
  retangulo: {
    width: '100%',
    height: '227px',
    backgroundColor: '#edf4ff',
    position: 'absolute'
  }
}));

const Cadastro = () => {
  const classes = useStyles();
  console.log(routes)
  return (
    <>
      {/* <CssBaseline> */}
        <Header/>
        <div className={classes.retangulo} />
        <Container maxWidth="sm">
          <Switch>
            {routes.map((prop, key) => {
              if (prop.redirect) {
                return <Redirect from={prop.path} to={prop.pathTo} key={key}/>;
              }

              return (
                <Route exact path={prop.path} component={prop.component} key={key}/>
              );
            })}
          </Switch>
        </Container>
        <Footer/>
      {/* </CssBaseline> */}
    </>
  );
}

export default Cadastro;
